'use client';

import styled from 'styled-components';

const StyledCardGrid = styled.div<{ $minMaxVal?: number }>`
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(
      ${(props) => (props.$minMaxVal ? `${props.$minMaxVal}px` : '280px')},
      1fr
    )
  );
  gap: var(--size-1);
  justify-items: center;
  width: 100%;
`;

export default StyledCardGrid;
